import { render, staticRenderFns } from "./Coater.vue?vue&type=template&id=20265986&"
import script from "./Coater.vue?vue&type=script&lang=js&"
export * from "./Coater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports